// extracted by mini-css-extract-plugin
export default {"ProjectPage":"style_ProjectPage__2dxSA"};